import {User} from "oidc-client-ts"
import {jwtDecode} from "jwt-decode"

export const loginAsBlankoUser = async () => {
    const params = new URLSearchParams({
        grant_type: 'password',
        client_id: window._env_.CLIENT_ID,
        username: window._env_.AUTH_USER,
        password: window._env_.AUTH_PASSWORD,
        scope: 'openid profile email'
    })

    const response = await fetch(`${window._env_.AUTHORITY}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: params
    })

    if (!response.ok) throw new Error("Login failed")

    return await response.json()
};

export const applyBlankoLogin = async (userManager) => {
    const data = await loginAsBlankoUser()
    const user = new User({
        access_token: data.access_token,
        id_token: data.id_token,
        refresh_token: data.refresh_token,
        token_type: data.token_type,
        scope: data.scope,
        expires_at: data.expires_in
            ? Math.floor(Date.now() / 1000) + data.expires_in
            : undefined,
        profile: jwtDecode(data.id_token)
    })
    await userManager.storeUser(user)
    await userManager.events.load(user)
    return user
}